// import React, { useState, useRef } from 'react';
// import { QRCodeCanvas } from 'qrcode.react';
// import { X, Printer, Plus, Minus } from 'lucide-react';
// import { useReactToPrint } from 'react-to-print';

// const StickersPrint = ({ product, onClose }) => {
//   const [copies, setCopies] = useState(1);
//   const [inputValue, setInputValue] = useState('1');
//   const componentRef = useRef();

//   const ITEMS_PER_PAGE = 30;

//   const handlePrint = useReactToPrint({
//     contentRef: componentRef,
//     documentTitle: `Stickers-${product.name}`,
//     pageStyle: `
//       @page {
//         size: A4;
//         margin: 5mm;
//       }
      
//       body {
//         margin: 0;
//         padding: 0;
//         background: white;
//       }
      
//       .print-page {
//         page-break-after: always;
//         page-break-inside: avoid;
//         min-height: 277mm;
//         background: white !important;
//         padding: 5mm;
//         box-sizing: border-box;
//       }
      
//       .print-page:last-child {
//         page-break-after: auto;
//       }
      
//       .printable-grid {
//         display: grid !important;
//         grid-template-columns: repeat(5, 1fr) !important;
//         gap: 15px 8px !important;
//         width: 100% !important;
//       }
      
//       .sticker-item {
//         display: flex !important;
//         flex-direction: column !important;
//         align-items: center !important;
//         padding: 1px !important;
//         border: 1px solid #eee !important;
//         text-align: center !important;
//         page-break-inside: avoid !important;
//         break-inside: avoid !important;
//       }
      
//       .qr-container {
//         background: white !important;
//         display: flex !important;
//         justify-content: center !important;
//         margin-bottom: 2px !important;
//       }
      
//       * {
//         -webkit-print-color-adjust: exact !important;
//         print-color-adjust: exact !important;
//       }
//     `,
//     onBeforeGetContent: async () => {
//       // You can add any preparation logic here if needed
//     },
//     onAfterPrint: () => {
//       console.log('Print completed');
//     },
//     removeAfterPrint: true,
//   });

//   // Handle input change
//   const handleInputChange = (e) => {
//     const value = e.target.value;
//     setInputValue(value);
    
//     // Only update copies if it's a valid number
//     const num = parseInt(value);
//     if (!isNaN(num) && num >= 1) {
//       setCopies(num);
//     }
//   };

//   // Handle input blur (when user leaves the input)
//   const handleInputBlur = () => {
//     const num = parseInt(inputValue);
//     if (isNaN(num) || num < 1) {
//       setCopies(1);
//       setInputValue('1');
//     } else {
//       setCopies(num);
//       setInputValue(num.toString());
//     }
//   };

//   // Handle key press (Enter key)
//   const handleKeyPress = (e) => {
//     if (e.key === 'Enter') {
//       handleInputBlur();
//     }
//   };

//   // Increment copies
//   const incrementCopies = () => {
//     const newValue = copies + 1;
//     setCopies(newValue);
//     setInputValue(newValue.toString());
//   };

//   // Decrement copies
//   const decrementCopies = () => {
//     const newValue = Math.max(1, copies - 1);
//     setCopies(newValue);
//     setInputValue(newValue.toString());
//   };

//   // Sort variants by color then size
//   const sortedVariants = product.has_variants 
//     ? [...(product.variants || [])].sort((a, b) => {
//         const colorComp = a.color.localeCompare(b.color);
//         if (colorComp !== 0) return colorComp;
        
//         const sizeOrder = { 'XS': 1, 'S': 2, 'M': 3, 'L': 4, 'XL': 5, 'XXL': 6, 'XXXL': 7 };
//         const aOrder = sizeOrder[a.size] || 99;
//         const bOrder = sizeOrder[b.size] || 99;
//         return aOrder - bOrder;
//       })
//     : [];

//   // Prepare base items
//   const baseItems = product.has_variants 
//     ? sortedVariants.map(v => ({
//         barcode: v.barcode || product.barcode,
//         name: `${product.name}`,
//         variant: `(${v.color}, ${v.size})`,
//         price: product.price,
//       }))
//     : [{
//         barcode: product.barcode,
//         name: product.name,
//         variant: '',
//         price: product.price,
//       }];

//   // Repeat each item based on copies
//   const items = [];
//   baseItems.forEach(item => {
//     for (let i = 0; i < copies; i++) {
//       items.push(item);
//     }
//   });

//   // Split items into pages
//   const pages = [];
//   for (let i = 0; i < items.length; i += ITEMS_PER_PAGE) {
//     pages.push(items.slice(i, i + ITEMS_PER_PAGE));
//   }

//   // If no items, don't render
//   if (!product) return null;

//   return (
//     <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4 overflow-y-auto">
//       <div className="bg-white dark:bg-gray-900 rounded-xl shadow-2xl w-full max-w-5xl my-auto flex flex-col max-h-[90vh]">
        
//         {/* Header */}
//         <div className="flex items-center justify-between p-4 border-b border-gray-100 dark:border-gray-800 sticky top-0 bg-white dark:bg-gray-900 z-10">
//           <div>
//             <h2 className="text-xl font-bold text-gray-900 dark:text-gray-100">Imprimer des stickers</h2>
//             <p className="text-sm text-gray-500 truncate max-w-xs">{product.name}</p>
//             {items.length > ITEMS_PER_PAGE && (
//               <p className="text-xs text-blue-600 mt-1">
//                 {pages.length} pages ({items.length} stickers)
//               </p>
//             )}
//           </div>
          
//           <div className="flex items-center gap-4">
//             <div className="flex items-center gap-1 bg-gray-100 dark:bg-gray-800 p-1 rounded-lg">
//               <span className="text-xs font-medium px-2">Copies:</span>
//               <button 
//                 onClick={decrementCopies}
//                 className="p-1 hover:bg-white rounded shadow-sm transition-all"
//                 disabled={copies <= 1}
//               >
//                 <Minus className="w-3 h-3" />
//               </button>
              
//               {/* Input field for direct number entry */}
//               <input
//                 type="text"
//                 value={inputValue}
//                 onChange={handleInputChange}
//                 onBlur={handleInputBlur}
//                 onKeyPress={handleKeyPress}
//                 className="w-16 text-center text-sm font-bold bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 min="1"
//               />
              
//               <button 
//                 onClick={incrementCopies}
//                 className="p-1 hover:bg-white rounded shadow-sm transition-all"
//               >
//                 <Plus className="w-3 h-3" />
//               </button>
//             </div>

//             <button
//               onClick={handlePrint}
//               className="flex items-center gap-2 bg-black text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-gray-800 transition-colors"
//             >
//               <Printer className="w-4 h-4" />
//               Imprimer {pages.length > 1 ? `(${pages.length} pages)` : ''}
//             </button>
//             <button
//               onClick={onClose}
//               className="p-2 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full transition-colors text-gray-500"
//             >
//               <X className="w-5 h-5" />
//             </button>
//           </div>
//         </div>

//         {/* Preview Content - Scrollable */}
//         <div className="flex-1 overflow-y-auto p-8 bg-gray-100 dark:bg-gray-950">
//           {/* This div is what will be printed */}
//           <div ref={componentRef} className="print-content">
//             {/* Render each page */}
//             {pages.map((pageItems, pageIndex) => (
//               <div 
//                 key={pageIndex} 
//                 className="print-page bg-white mb-8 last:mb-0"
//                 style={{ 
//                   width: '210mm',
//                   minHeight: '297mm',
//                   padding: '5mm',
//                   margin: '0 auto',
//                   position: 'relative',
//                   boxSizing: 'border-box',
//                   pageBreakAfter: pageIndex < pages.length - 1 ? 'always' : 'auto',
//                 }}
//               >
//                 {/* Page number (preview only) */}
//                 {pages.length > 1 && (
//                   <div className="absolute top-2 right-4 text-xs text-gray-400 z-10">
//                     Page {pageIndex + 1} / {pages.length}
//                   </div>
//                 )}
                
//                 {/* Grid for stickers: 5 columns */}
//                 <div className="grid grid-cols-5 gap-y-5 gap-x-4">
//                   {pageItems.map((item, idx) => (
//                     <div key={`${pageIndex}-${idx}`} className="flex flex-col items-center p-1 border border-gray-100 rounded text-center">
//                       {item.barcode ? (
//                         <div className="mb-0 bg-white p-1 rounded">
//                           <QRCodeCanvas 
//                             value={item.barcode} 
//                             size={110}
//                             level="M"
//                             includeMargin={false}
//                           />
//                         </div>
//                       ) : (
//                         <div className="mb-2 w-[110px] h-[110px] bg-red-50 border-2 border-dashed border-red-200 rounded flex items-center justify-center p-2">
//                            <p className="text-[10px] text-red-500 font-bold">Code-barres manquant</p>
//                         </div>
//                       )}
//                       <div className="text-[10px] font-bold text-gray-900 leading-tight line-clamp-2">
//                         {item.name}
//                       </div>
//                       {item.variant && (
//                         <div className="text-[8px] font-bold text-blue-700 uppercase bg-blue-50 px-2 rounded-full mt-1">
//                           {item.variant}
//                         </div>
//                       )}
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default StickersPrint;

import React, { useState, useRef } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { X, Printer, Plus, Minus } from 'lucide-react';
import { useReactToPrint } from 'react-to-print';
import { useTranslation } from '../LanguageContext';

const StickersPrint = ({ product, onClose }) => {
  const [copies, setCopies] = useState(1);
  const [inputValue, setInputValue] = useState('1');
  const componentRef = useRef();
  const { t } = useTranslation();

  const ITEMS_PER_PAGE = 30;

  const handlePrint = useReactToPrint({
    contentRef: componentRef,
    documentTitle: `Stickers-${product.name}`,
    pageStyle: `
      @page {
        size: A4;
        margin: 5mm;
      }
      
      body {
        margin: 0;
        padding: 0;
        background: white;
      }
      
      .print-page {
        page-break-after: always;
        page-break-inside: avoid;
        min-height: 277mm;
        background: white !important;
        padding: 5mm;
        box-sizing: border-box;
      }
      
      .print-page:last-child {
        page-break-after: auto;
      }
      
      .printable-grid {
        display: grid !important;
        grid-template-columns: repeat(5, 1fr) !important;
        gap: 15px 8px !important;
        width: 100% !important;
      }
      
      .sticker-item {
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
        padding: 1px !important;
        border: 1px solid #eee !important;
        text-align: center !important;
        page-break-inside: avoid !important;
        break-inside: avoid !important;
      }
      
      .qr-container {
        background: white !important;
        display: flex !important;
        justify-content: center !important;
        margin-bottom: 2px !important;
      }
      
      * {
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
      }
    `,
    onBeforeGetContent: async () => {
      // You can add any preparation logic here if needed
    },
    onAfterPrint: () => {
      console.log('Print completed');
    },
    removeAfterPrint: true,
  });

  // Handle input change
  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    
    // Only update copies if it's a valid number
    const num = parseInt(value);
    if (!isNaN(num) && num >= 1) {
      setCopies(num);
    }
  };

  // Handle input blur (when user leaves the input)
  const handleInputBlur = () => {
    const num = parseInt(inputValue);
    if (isNaN(num) || num < 1) {
      setCopies(1);
      setInputValue('1');
    } else {
      setCopies(num);
      setInputValue(num.toString());
    }
  };

  // Handle key press (Enter key)
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleInputBlur();
    }
  };

  // Increment copies
  const incrementCopies = () => {
    const newValue = copies + 1;
    setCopies(newValue);
    setInputValue(newValue.toString());
  };

  // Decrement copies
  const decrementCopies = () => {
    const newValue = Math.max(1, copies - 1);
    setCopies(newValue);
    setInputValue(newValue.toString());
  };

  // Get variant display text based on type
  const getVariantDisplayText = (variant, variantType) => {
    if (variantType === 'colors') {
      return variant.color;
    } else if (variantType === 'sizes') {
      return variant.size;
    } else {
      // Both colors and sizes
      return `${variant.color}, ${variant.size}`;
    }
  };

  // Detect variant type from product variants
  const detectVariantType = () => {
    if (!product.has_variants || !product.variants || product.variants.length === 0) {
      return 'none';
    }
    
    const hasColors = product.variants.some(v => v.color);
    const hasSizes = product.variants.some(v => v.size);
    
    if (hasColors && hasSizes) return 'both';
    if (hasColors && !hasSizes) return 'colors';
    if (!hasColors && hasSizes) return 'sizes';
    return 'none';
  };

  const variantType = detectVariantType();

  // Sort variants based on type
  const sortedVariants = product.has_variants 
    ? [...(product.variants || [])].sort((a, b) => {
        if (variantType === 'colors') {
          // Sort by color name only
          return (a.color || '').localeCompare(b.color || '');
        } else if (variantType === 'sizes') {
          // Sort sizes logically
          const sizeOrder = { 'XS': 1, 'S': 2, 'M': 3, 'L': 4, 'XL': 5, 'XXL': 6, 'XXXL': 7 };
          const aOrder = sizeOrder[a.size] || 99;
          const bOrder = sizeOrder[b.size] || 99;
          return aOrder - bOrder;
        } else {
          // Sort by color then size (both)
          const colorComp = (a.color || '').localeCompare(b.color || '');
          if (colorComp !== 0) return colorComp;
          
          const sizeOrder = { 'XS': 1, 'S': 2, 'M': 3, 'L': 4, 'XL': 5, 'XXL': 6, 'XXXL': 7 };
          const aOrder = sizeOrder[a.size] || 99;
          const bOrder = sizeOrder[b.size] || 99;
          return aOrder - bOrder;
        }
      })
    : [];

  // Prepare base items based on variant type
  const getBaseItems = () => {
    if (!product.has_variants) {
      return [{
        barcode: product.barcode,
        name: product.name,
        variantText: '',
        variantValue: null,
        colorValue: null,
      }];
    }

    if (variantType === 'colors') {
      // Colors-only: one sticker per color
      const uniqueColors = [...new Map(
        sortedVariants.map(v => [v.color, v])
      ).values()];
      
      return uniqueColors.map(v => ({
        barcode: v.barcode || product.barcode,
        name: product.name,
        variantText: v.color,
        variantValue: v.value_color,
        colorValue: v.value_color,
      }));
    }
    
    if (variantType === 'sizes') {
      // Sizes-only: one sticker per size
      const uniqueSizes = [...new Map(
        sortedVariants.map(v => [v.size, v])
      ).values()];
      
      return uniqueSizes.map(v => ({
        barcode: v.barcode || product.barcode,
        name: product.name,
        variantText: v.size,
        variantValue: null,
        colorValue: null,
      }));
    }
    
    // Both colors and sizes: sticker for each variant
    return sortedVariants.map(v => ({
      barcode: v.barcode || product.barcode,
      name: product.name,
      variantText: `${v.color}, ${v.size}`,
      variantValue: v.value_color,
      colorValue: v.value_color,
    }));
  };

  const baseItems = getBaseItems();

  // Repeat each item based on copies
  const items = [];
  baseItems.forEach(item => {
    for (let i = 0; i < copies; i++) {
      items.push(item);
    }
  });

  // Split items into pages
  const pages = [];
  for (let i = 0; i < items.length; i += ITEMS_PER_PAGE) {
    pages.push(items.slice(i, i + ITEMS_PER_PAGE));
  }

  // If no items, don't render
  if (!product) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4 overflow-y-auto">
      <div className="bg-white dark:bg-gray-900 rounded-xl shadow-2xl w-full max-w-5xl my-auto flex flex-col max-h-[90vh]">
        
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-100 dark:border-gray-800 sticky top-0 bg-white dark:bg-gray-900 z-10">
          <div>
            <h2 className="text-xl font-bold text-gray-900 dark:text-gray-100">{t('print.title')}</h2>
            <p className="text-sm text-gray-500 truncate max-w-xs">{product.name}</p>
            <div className="flex items-center gap-2 mt-1">
              {variantType !== 'none' && (
                <span className="text-xs px-2 py-0.5 bg-blue-100 dark:bg-blue-900 text-blue-700 dark:text-blue-300 rounded-full">
                  {variantType === 'colors' && `${baseItems.length} ${t('print.colors')}`}
                  {variantType === 'sizes' && `${baseItems.length} ${t('print.sizes')}`}
                  {variantType === 'both' && `${baseItems.length} ${t('print.variants')}`}
                </span>
              )}
              {items.length > ITEMS_PER_PAGE && (
                <span className="text-xs text-blue-600 dark:text-blue-400">
                  {pages.length} {t('print.pages')} ({items.length} {t('print.stickers')})
                </span>
              )}
            </div>
          </div>
          
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-1 bg-gray-100 dark:bg-gray-800 p-1 rounded-lg">
              <span className="text-xs font-medium px-2">{t('print.copies')}</span>
              <button 
                onClick={decrementCopies}
                className="p-1 hover:bg-white rounded shadow-sm transition-all"
                disabled={copies <= 1}
              >
                <Minus className="w-3 h-3" />
              </button>
              
              {/* Input field for direct number entry */}
              <input
                type="text"
                value={inputValue}
                onChange={handleInputChange}
                onBlur={handleInputBlur}
                onKeyPress={handleKeyPress}
                className="w-16 text-center text-sm font-bold bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-500"
                min="1"
              />
              
              <button 
                onClick={incrementCopies}
                className="p-1 hover:bg-white rounded shadow-sm transition-all"
              >
                <Plus className="w-3 h-3" />
              </button>
            </div>

            <button
              onClick={handlePrint}
              className="flex items-center gap-2 bg-black text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-gray-800 transition-colors"
            >
              <Printer className="w-4 h-4" />
              {t('print.print')}{pages.length > 1 ? ` (${pages.length} ${t('print.pages')})` : ''}
            </button>
            <button
              onClick={onClose}
              className="p-2 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full transition-colors text-gray-500"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>

        {/* Preview Content - Scrollable */}
        <div className="flex-1 overflow-y-auto p-8 bg-gray-100 dark:bg-gray-950">
          {/* This div is what will be printed */}
          <div ref={componentRef} className="print-content">
            {/* Render each page */}
            {pages.map((pageItems, pageIndex) => (
              <div 
                key={pageIndex} 
                className="print-page bg-white mb-8 last:mb-0"
                style={{ 
                  width: '210mm',
                  minHeight: '297mm',
                  padding: '5mm',
                  margin: '0 auto',
                  position: 'relative',
                  boxSizing: 'border-box',
                  pageBreakAfter: pageIndex < pages.length - 1 ? 'always' : 'auto',
                }}
              >
                {/* Page number (preview only) */}
                {pages.length > 1 && (
                  <div className="absolute top-2 right-4 text-xs text-gray-400 z-10">
                    {t('print.page')} {pageIndex + 1} / {pages.length}
                  </div>
                )}
                
                {/* Grid for stickers: 5 columns */}
                <div className="grid grid-cols-5 gap-y-5 gap-x-4">
                  {pageItems.map((item, idx) => (
                    <div key={`${pageIndex}-${idx}`} className="flex flex-col items-center p-1 border border-gray-100 rounded text-center">
                      {item.barcode ? (
                        <div className="mb-0 bg-white p-1 rounded">
                          <QRCodeCanvas 
                            value={item.barcode} 
                            size={110}
                            level="M"
                            includeMargin={false}
                          />
                        </div>
                      ) : (
                        <div className="mb-2 w-[110px] h-[110px] bg-red-50 border-2 border-dashed border-red-200 rounded flex items-center justify-center p-2">
                           <p className="text-[10px] text-red-500 font-bold text-center">
                             {t('print.missing_barcode')}
                           </p>
                        </div>
                      )}
                      
                      {/* {item.colorValue && variantType === 'colors' && (
                        <div className="mb-1">
                          <div 
                            className="w-6 h-6 rounded-full border border-gray-300 mx-auto"
                            style={{ backgroundColor: item.colorValue }}
                            title={item.variantText}
                          />
                        </div>
                      )} */}
                      
                      <div className="text-[10px] font-bold text-gray-900 leading-tight line-clamp-2 px-1">
                        {item.name.length > 20
                          ? `${item.name.substring(0, 20)}`
                          : item.name}
                      </div>
                      
                      {item.variantText && (
                        <div className={`text-[8px] font-bold uppercase px-2 rounded-full mt-0.5 ${
                          variantType === 'colors' 
                            ? 'bg-purple-50 text-purple-700' 
                            : variantType === 'sizes'
                            ? 'bg-green-50 text-green-700'
                            : 'bg-blue-50 text-blue-700'
                        }`}>
                          {item.variantText}
                        </div>
                      )}
                      
                      {/* Show stock info if available (optional) */}
                      {item.stock && (
                        <div className="text-[7px] text-gray-400 mt-0.5">
                          {t('print.stock')} {item.stock}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StickersPrint;